import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logoutSuccess } from "../../authentication/AuthActions";
import Login from "../login/login.tsx";
import "./AuthHeader.css";


const AuthHeader: React.FC = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();  // ← qui
    const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);
    const user = useSelector((state: any) => state.auth.user)?.user;
    const [isLoginOpen, setIsLoginOpen] = useState(false);

    const isStartPage = location.pathname === "/start";
    const isWelcomePage = location.pathname === "/welcome";

    const handleMyAnalysis = () => {
        navigate("/welcome");
    };

    const handleLogout = () => {
        dispatch(logoutSuccess());
    };

  
    const handleLoginClick = () => {
        setIsLoginOpen(true);
    };

    const handleCloseLogin = () => {
        setIsLoginOpen(false);
    };

    return (
        <>
          <div className={`auth-header ${isWelcomePage ? "auth-header-black" : ""}`}>
                {isLoggedIn && user ? (
                    <>
                        {!isWelcomePage ? (
                            <span className="auth-header-username">
                                {"Welcome, "} <b>{user.userName}</b>
                            </span>
                        ) : (
                            <span className="auth-header-username">
                                {"Welcome, "} <b>{user.userName}</b>
                            </span>
                        )}
                        <button className="auth-header-profile-btn"  onClick={handleMyAnalysis}>
                            My analysis
                        </button>
                        <button className="auth-header-logout-btn" onClick={handleLogout}>
                            Logout
                        </button>
                    </>
                ) : (
                    !isStartPage && (
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <span className="auth-header-username">
                                Welcome,<b> Guest</b>
                            </span>

                            <button className="auth-header-login-btn" onClick={handleLoginClick}>
                                Login
                            </button>
                        </div>
                    )
                )}
            </div>
            <Login isOpen={isLoginOpen} onClose={handleCloseLogin} />
        </>
    );
};

export default AuthHeader;
